// extracted by mini-css-extract-plugin
export default {"addToCartControl":"A2-z","giftCard":"B2-z","btnContainer":"C2-z","cartButton":"D2-z","disabled":"E2-z"};